import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';
import MemberMiniMenu from '../menus/MemberMiniMenu';

const MemberWaiting = () => {
    return (
        <MemberMiniMenu><LinearProgress /></MemberMiniMenu>
    );
};

export default MemberWaiting;